module.exports = vendor_f60ad6a878250c32fcbb;